import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Box, LinearProgress } from '@mui/material';

import { ROUTE_EXPIRATION_PROMOTIONS } from '../../../../../../core/constants';
import useNotification from '../../../../../../core/hooks/use_notification';
import { getAutomaticExpirationPromotionSettingAction, getAutomaticExpirationPromotionSettingState, invalidateAutomaticExpirationPromotionSetting } from '../../../../../../features/price/get_automatic_expiration_promotion_setting';
import { getAutomaticExpirationPromotionSettingNotificationData } from '../../../../../../core/utils/notification_utils';
import AutomaticExpirationPromotionSettingForm from './automatic_expiration_promotion_setting_form';
import PageHeader from '../../../../../common/page_header';

const AutomaticExpirationPromotionSettingFormsPage = () => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    const getAutomaticExpirationPromotionSetting = useSelector(getAutomaticExpirationPromotionSettingState);

    useEffect(() => {
        dispatch(getAutomaticExpirationPromotionSettingAction(id))
            .then(response => showErrorMessage(getAutomaticExpirationPromotionSettingNotificationData(response)));

        return () => {
            dispatch(invalidateAutomaticExpirationPromotionSetting());
        };
    }, [dispatch, id, showErrorMessage]);

    const renderView = () => {
        if (getAutomaticExpirationPromotionSetting?.loading) {
            return (
                <Box mt={ 6 }>
                    <LinearProgress/>
                </Box>
            );
        }

        if (getAutomaticExpirationPromotionSetting?.data) {
            return (
                <AutomaticExpirationPromotionSettingForm id={ id }/>
            );
        }

        return null;
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3 } }>
            <PageHeader
                title="Edycja automatycznej promocji"
                showBack={ true }
                onBack={ () => navigate(ROUTE_EXPIRATION_PROMOTIONS, { state: { tab: location?.state?.tab } }) }
            />

            { renderView() }
        </Box>
    );
};

export default AutomaticExpirationPromotionSettingFormsPage;